import {
  AccountNonce,
  Address,
  Ether,
  L2ChainId,
  L2Signature,
  TokenSymbol,
} from 'types'
import { TxEthSignature } from 'utils/signer/types'
import { ApiV1Response, http } from './http'

export interface PostWithdrawBody {
  currency: TokenSymbol // 'BTC'
  toChainId: L2ChainId // 3
  to: Address // '0x00...0000'
  fee: Ether // '0.001'
  amount: Ether // '100.1'
  withdrawToL1: 0 | 1
  withdrawFeeRatio: number // 100
  nonce: AccountNonce // 0
  ts: number // 1684419923
  signature: L2Signature
  ethSignature: TxEthSignature
}

export async function postWithdraw<
  T extends ApiV1Response<{ id: number; txHash: string }>
>(accountId: number, data: PostWithdrawBody): Promise<T> {
  const r = await http.post<T>(`/account/${accountId}/withdraw`, data)
  return r.data
}
